module.exports = __webpack_public_path__ + "static/media/ep2in.0c7a48ce.png";